import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const WomensUALongSleeve = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[22].productName}
				color={product.allGear[22].color}
				size={product.allGear[22].sizes}
				price={product.allGear[22].price}
				img={product.allGear[22].img}
				miniImg1={product.allGear[22].miniImg1}
				miniImg2={product.allGear[22].miniImg2}
				miniImg3={product.allGear[22].miniImg3}
			/>
		</React.Fragment>
	);
};

export default WomensUALongSleeve;
